module.exports = __webpack_public_path__ + "img/bx-manage-activity.0d18281d.svg";